import type { WidgetConfiguration } from "../types";
import { Widget } from "../Widget";

type Custom = Record<string, never>;

type Props = WidgetConfiguration<Custom>;

export function Empty(props: Props): React.ReactNode {
	const { custom: _custom, ...rest } = props;

	return <Widget {...rest} />;
}
